import * as CONST from "../../../app/constants"
import { isChangeRequestTypeApplication, isRenewalTypeApplication } from "../../slice/applicationsUtils";
import { isReviewDataNeeded } from "../bltReviewSelector";
import { fullName } from "../../../app/utils"
import {
    getUpdatedDocuemntsWithReviewData,
    isHavingUpdatedDocuments,
    parseAIRInformationForRenewal,
    parseAppointedAgentInformation,
    parseAppointedAgentInformationForRenewal,
    parseCompanyTypeInformationForRenewal,
    parseComplainceOfficerChangeRequestAgentEmail,
    parseCriminalRecordsCheckInformation,
    parseCriminalRecordsCheckInformationForRenewal,
    parseFinancialRecordsInformation,
    parseFinancialRecordsInformationForRenewal,
    parseFiscalYearInformation,
    parseFiscalYearInformationForRenewal,
    parseInsuranceInformation,
    parseInsuranceInformationForRenewal,
    parseLenderOrAdministratorChangeRequestInformation,
    parseMortgageApplicantInformation,
    parseMortgageApplicantInformationForRenewal,
    // parseNotAddedDocumentsInformation,
    parsePrincipalBrokerInformation,
    parsePrincipalBrokerInformationForRenewal,
    parseServiceAddressInformation,
    parseServiceAddressInformationForRenewal,
    parseUpdatedDocumentsInformation
} from "./bltReviewMortgageApplication";

export function parseLenderConfirmationInformationForRenewal(applicationItem) {
    const { isMRACompliance } = applicationItem

    return [{
        duty: "Are you in compliance with the Mortgage Act and regulations?",
        confirmation: isMRACompliance ? "Yes" : "No",
        review: null
    }]
}

export function parseLenderQualificationInformationMap(applicationItem) {
    const qualification1 = "Is the Compliance Officer 19 years of age or older?"
    const qualification2 = "Is the Compliance Officer a resident of Canada?"
    const qualification3 = "The CO is engaged in the activities of the licensee to the extent that the individual is capable of carrying out their duties and responsibilities under the Act and its regulations."

    return [{
        [qualification1]: "Yes",
        review: ""
    }, {
        [qualification2]: "Yes",
        review: ""
    }, {
        [qualification3]: "Yes",
        review: ""
    }]
}

function parseLenderConfirmationInformation(applicationItem) {
    const businessContact = applicationItem?.complianceOfficer ?? applicationItem?.mainBusinessContact

    return [{
        duty: `I, ${fullName(businessContact)} confirm that I am engaged with the activities with the mortgage lender to the extent I am capable of carrying out my duties and responsibilites as Compliance Officer under the Mortgage Regulation Act and its regulations.`,
        confirmation: "Yes",
        review: ""
    }, {
        duty: `I, ${fullName(businessContact)} confirm that I have read and understand the Mortgage Regulation Act and its regulations and I agree to carry out my duties and responsibilities under the Act and its regulations.`,
        confirmation: "Yes",
        review: ""
    }]
}

export function lenderReviewDataDetails(
    queueItem,
    primaryAgencyApplication) {
    let sectionsByOrder = [];
    let businessLicenceData = {};
    const commonSections = ["internalNotesMap", "decisionMap"];

    if (queueItem?.licencingSubType ===
        CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "principalBrokerInformationMap",
            "financialRecordsInformationMap",
            "appointedAgentInformationMap",
            "serviceAddressInformationMap",
            "criminalRecordsCheckInformationMap",
            "insuranceInformationMap",
            "fiscalYearInformationMap",
            "confirmationInformationMap",
        ]
    } else if (queueItem?.licencingSubType ===
        CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "principalBrokerInformationMap",
            "brokerQualificationInformationMap",
            "airInformationMap",
            "companyTypeInformationMap",
            "financialRecordsInformationMap",
            "appointedAgentInformationMap",
            "serviceAddressInformationMap",
            "criminalRecordsCheckInformationMap",
            "insuranceInformationMap",
            "fiscalYearInformationMap",
            "confirmationInformationMap",
        ]
    } else if (queueItem?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData
        sectionsByOrder = [
            "changeRequestDetailsMap",
            "changeRequestNewAgentEmailMap",
        ]
    }

    if (isHavingUpdatedDocuments(queueItem)) {
       if(queueItem?.licenceStatus === CONST.LICENCE_STATUS_ACTIVE) {
            //Ignoring other sections for ACTIVE licence status
            sectionsByOrder = ["updatedDocumentsMap", ...commonSections];
        }
        else {
            sectionsByOrder = [...sectionsByOrder, "updatedDocumentsMap", ...commonSections];
        }
    } else {
        sectionsByOrder = [...sectionsByOrder, ...commonSections];
    }

    return { businessLicenceData, sectionsByOrder };
}

export function bltMortgageLenderReviewData(lenderApplication, agencyApplicationArchive) {
    const applicationItem = lenderApplication.businessLicenceData
    const { documents } = lenderApplication

    if (isReviewDataNeeded(applicationItem)) {

        const isRenewal = isRenewalTypeApplication(lenderApplication)

        let applicantInformationMap = [{}]
        let principalBrokerInformationMap = [{}]
        let financialRecordsInformationMap = [{}]
        let appointedAgentInformationMap = [{}]
        let serviceAddressInformationMap = [{}]
        let criminalRecordsCheckInformationMap = [{}]
        let insuranceInformationMap = [{}]
        let confirmationInformationMap = [{}]
        let fiscalYearInformationMap = [{}]
        let companyTypeInformationMap = [{}]
        let airInformationMap = [{}]
        let brokerQualificationInformationMap = [{}]
        let changeRequestDetailsMap = [{}]
        let changeRequestNewAgentEmailMap = [{}]

        if (isRenewal) {
            const applicationItemArchive = agencyApplicationArchive?.businessLicenceData

            applicantInformationMap = parseMortgageApplicantInformationForRenewal(applicationItem, applicationItemArchive)
            principalBrokerInformationMap = parsePrincipalBrokerInformationForRenewal(applicationItem, applicationItemArchive)
            brokerQualificationInformationMap = parseLenderQualificationInformationMap(applicationItem)
            financialRecordsInformationMap = parseFinancialRecordsInformationForRenewal(applicationItem, applicationItemArchive)
            appointedAgentInformationMap = parseAppointedAgentInformationForRenewal(applicationItem, applicationItemArchive)
            serviceAddressInformationMap = parseServiceAddressInformationForRenewal(applicationItem, applicationItemArchive)
            criminalRecordsCheckInformationMap = parseCriminalRecordsCheckInformationForRenewal(applicationItem, documents, agencyApplicationArchive)
            insuranceInformationMap = parseInsuranceInformationForRenewal(applicationItem, documents)
            confirmationInformationMap = parseLenderConfirmationInformationForRenewal(applicationItem, applicationItemArchive)
            fiscalYearInformationMap = parseFiscalYearInformationForRenewal(applicationItem, applicationItemArchive)
            companyTypeInformationMap = parseCompanyTypeInformationForRenewal(applicationItem, applicationItemArchive)
            airInformationMap = parseAIRInformationForRenewal(applicationItem, documents)
        } else {
            if (!isChangeRequestTypeApplication(lenderApplication)) {
                applicantInformationMap = parseMortgageApplicantInformation(applicationItem)
                principalBrokerInformationMap = parsePrincipalBrokerInformation(applicationItem)
                financialRecordsInformationMap = parseFinancialRecordsInformation(applicationItem)
                appointedAgentInformationMap = parseAppointedAgentInformation(applicationItem)
                serviceAddressInformationMap = parseServiceAddressInformation(applicationItem)
                criminalRecordsCheckInformationMap = parseCriminalRecordsCheckInformation(applicationItem, documents)
                insuranceInformationMap = parseInsuranceInformation(applicationItem, documents)
                confirmationInformationMap = parseLenderConfirmationInformation(applicationItem)
                fiscalYearInformationMap = parseFiscalYearInformation(applicationItem)
            }
            else {
                changeRequestDetailsMap = parseLenderOrAdministratorChangeRequestInformation(applicationItem);
                changeRequestNewAgentEmailMap = parseComplainceOfficerChangeRequestAgentEmail(applicationItem)
            }
        }

        const decisionMap = [{
            adminDecision: "",
            review: ""
        }]

        const internalNotesMap = [{
            internalNotes: applicationItem.internalNotes,
            review: (applicationItem.internalNotes?.length > 0) ? "complete" : ""
        }]

        const reviewMaps = {
            applicantInformationMap,
            airInformationMap,
            brokerQualificationInformationMap,
            principalBrokerInformationMap,
            companyTypeInformationMap,
            financialRecordsInformationMap,
            appointedAgentInformationMap,
            serviceAddressInformationMap,
            criminalRecordsCheckInformationMap,
            insuranceInformationMap,
            fiscalYearInformationMap,
            confirmationInformationMap,
            changeRequestDetailsMap,
            changeRequestNewAgentEmailMap,
            internalNotesMap,
            decisionMap
        }

        // const documentsContainingMaps = {
        //     insuranceInformationMap,
        //     criminalRecordsCheckInformationMap,
        //     airInformationMap
        // }
        // const updatedDocumentsNotAdded = parseNotAddedDocumentsInformation(applicationItem, documentsContainingMaps, documents);
       
        const updatedDocumentsNotAdded = parseUpdatedDocumentsInformation(applicationItem, documents);
        if(updatedDocumentsNotAdded?.length) {
            reviewMaps.updatedDocumentsMap = updatedDocumentsNotAdded
        }

        return reviewMaps
    }
    else if (isHavingUpdatedDocuments(lenderApplication)) {
       applicationItem.reviewDataCollectionDebt = getUpdatedDocuemntsWithReviewData(applicationItem, documents, lenderApplication.licenceStatus)
    }

    return applicationItem.reviewDataCollectionDebt
}